import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { passwordChangeusername, sendOTPUsername } from './Services/ForgetService';
import Swal from 'sweetalert2';
import { rsaService } from "../api/auth/rsaService";

export default function Forget() {

  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [passwords, setPasswords] = useState('');
  const [conpassword, setConpassword] = useState('');
  const [otp, setOtp] = useState('');
  const [otpError, setOtpError] = useState('');
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);

  const [showPasswordp, setShowPasswordp] = useState(false);
  const [showPasswordc, setShowPasswordc] = useState(false);
  const [showPasswordo, setShowPasswordo] = useState(false);

  // Load scripts (unchanged)
  useEffect(() => {
    const scriptUrls = [
      "assets/js/jquery-3.7.1.min.js",
      "assets/js/bootstrap.bundle.min.js",
      "assets/js/script.js"
    ];

    let isCancelled = false;

    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.async = false;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
    };
  }, []);

  // ✅ Email OR Phone validation
  const validateEmailOrPhone = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;
    return emailRegex.test(value) || phoneRegex.test(value);
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    
    if (/^[a-zA-Z0-9@._]*$/.test(value)) {
      setUsername(value);
    }

    if (value.trim() === "") {
      setUsernameError("");
      return;
    }

    const isLocalPhone = /^[0-9]+$/.test(value);
    if (isLocalPhone) {
      if (value.length !== 10) {
        setUsernameError("Phone number must be exactly 10 digits");
      } else {
        setUsernameError("");
      }
    } else {
      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      if (!isEmail) {
        setUsernameError("Enter valid email or 10-digit phone number");
      } else {
        setUsernameError("");
      }
    }
  };

  const handleOtpChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value)) {
      setOtp(value);
      if (value.length > 0 && value.length !== 6) {
        setOtpError("OTP must be exactly 6 digits");
      } else {
        setOtpError("");
      }
    }
  };

  // ✅ Send OTP
  const sendOtp = async (e) => {
    e.preventDefault();
    let isValid = true;

    if (!username.trim()) {
      setUsernameError("E-mail / Phone is required");
      isValid = false;
    } else if (!validateEmailOrPhone(username)) {
      setUsernameError("Enter valid email or 10-digit phone number");
      isValid = false;
    }

    if (!isValid) return;

    try {
      setIsSendingOtp(true);
      const response = await sendOTPUsername(username);

      if (response?.ok || response?.status === 200) {
        const res = response.data;
              
                    if (res.statusCode === "OK") {
                      Swal.fire({
                        title: 'Success!',
                        text: res.data,
                        icon: 'success',
                        confirmButtonColor: '#566fe2'
                      }).then(() => {
                        setShowOtpInput(true);
                      });
              
                    } else {
                      Swal.fire({
                        title: 'Error!',
                        text: res.data,
                        icon: 'error',
                        confirmButtonColor: '#d33'
                      });
                    }
        
      } else {
        Swal.fire("Error", "Failed to send OTP", "error");
      }

    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setIsSendingOtp(false);
    }
  };

  // ✅ Validate OTP
  const validateOTP = async (e) => {
    e.preventDefault();

    if (!otp || otp.length !== 6) {
      setOtpError("OTP must be exactly 6 digits");
      return;
    } else {
      setOtpError("");
    }

    if (!passwords || !conpassword) {
      Swal.fire("Error", "Password fields are required", "error");
      return;
    }

    if (passwords !== conpassword) {
      Swal.fire("Error", "Passwords do not match", "error");
      return;
    }

    if (passwords.length < 8 || passwords.length > 20) {
      Swal.fire("Error", "Password must be 8-20 characters long", "error");
      return;
    }

    try {
      const encryptedPassword = await rsaService.encrypt(passwords);

      const response = await passwordChangeusername(
        username,
        encryptedPassword,
        otp
      );

      if (response?.data?.statusCode === "OK" ) {
        Swal.fire("Success", response?.data?.data, "success");
        setShowOtpInput(false);
        navigate("/login");
      } else {
        setShowOtpInput(true);
        Swal.fire("Error", response?.data?.data, "error");
      }

      
      setPasswords('');
      setConpassword('');
      setOtp('');
      setOtpError('');

    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  // Toggle functions (UNCHANGED STYLE)
  const togglePasswordp = () => setShowPasswordp(prev => !prev);
  const togglePasswordc = () => setShowPasswordc(prev => !prev);
  const togglePasswordo = () => setShowPasswordo(prev => !prev);

  return (
    <>
      <style>
        {`
        .pass-group {
          position: relative;
          display: flex;
          align-items: center;
        }

        .pass-group .pass-input {
          width: 100%;
          padding-right: 45px;
        }

        .pass-group span {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 18px;
          color: #6c757d;
          cursor: pointer;
        }

        .pass-group span:hover {
          color: #000;
        }
      `}
      </style>

      <div className="content">
        <div className="container-fluid">
          <div className="row mt-4">
            <div className="col-md-8 offset-md-2">

              <div className="account-content" style={{ marginTop: "25px", border: "1px solid #9f9b9b", padding: "30px", borderRadius: "8px", boxShadow: "0 3px 8px rgba(0,0,0,0.24)" }}>

                <div className="row align-items-center justify-content-center">

                  <div className="col-md-7 col-lg-6 login-left">
                    <img src="assets/img/login-banner.png" className="img-fluid" alt="Webnet Login" />
                  </div>

                  <div className="col-md-12 col-lg-6 login-right">
                    <div className="login-header">
                      <h3>Login <span>Webnet HMS</span></h3>
                    </div>

                    <form>

                      {/* Email / Phone */}
                      <div className="mb-3">
                        <label className="form-label">E-mail / Phone</label>
                        <input
                          type="text"
                          className="form-control"
                          value={username}
                          onChange={handleUsernameChange}
                        />
                        {usernameError && <small className="text-danger">{usernameError}</small>}
                      </div>

                      {!showOtpInput && (
                        <div className="d-flex gap-2 justify-content-end mb-3">
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => navigate('/login')}
                          >
                            Cancel
                          </button>

                          <button
                            className="btn btn-primary"
                            onClick={sendOtp}
                            disabled={isSendingOtp}
                          >
                            {isSendingOtp ? "Sending..." : "Send Otp"}
                          </button>
                        </div>
                      )}

                      {/* OTP & Passwords */}
                      {showOtpInput && (
                        <div className="mt-3">
                          <div className="mb-3">
                            <label className="form-label">Enter OTP</label>
                            <div className="pass-group">
                              <input
                                type={showPasswordo ? "text" : "password"}
                                className="form-control"
                                value={otp}
                                onChange={handleOtpChange}
                                maxLength={6}
                              />
                              <span onClick={togglePasswordo} className={`${showPasswordo ? "fa fa-eye" : "fa fa-eye-slash"}`} />
                            </div>
                            {otpError && <small className="text-danger">{otpError}</small>}
                          </div>

                          {/* Password */}
                          <div className="mb-3">
                            <label className="form-label">New Password</label>
                            <div className="pass-group">
                              <input
                                type={showPasswordp ? "text" : "password"}
                                className="form-control pass-input"
                                value={passwords}
                                onChange={(e) => setPasswords(e.target.value)}
                              />
                              <span onClick={togglePasswordp} className={`${showPasswordp ? "fa fa-eye" : "fa fa-eye-slash"}`} />
                            </div>
                          </div>

                          {/* Confirm Password */}
                          <div className="mb-3">
                            <label className="form-label">Confirm Password</label>
                            <div className="pass-group">
                              <input
                                type={showPasswordc ? "text" : "password"}
                                className="form-control pass-input"
                                value={conpassword}
                                onChange={(e) => setConpassword(e.target.value)}
                              />
                              <span onClick={togglePasswordc} className={`${showPasswordc ? "fa fa-eye" : "fa fa-eye-slash"}`} />
                            </div>
                          </div>

                          <div className="d-flex gap-2 justify-content-end mt-4">
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => navigate('/login')}
                            >
                              Cancel
                            </button>
                            <button
                              className="btn btn-success"
                              onClick={validateOTP}
                            >
                              Validate OTP & Change Password
                            </button>
                          </div>
                        </div>
                      )}

                    </form>

                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}